import type { CSSProperties } from "react";

import type { Spacing } from "@/styles/tokens";

export type MarginValue =
  | Spacing[keyof Spacing]
  | {
      top?: Spacing[keyof Spacing];
      bottom?: Spacing[keyof Spacing];
      left?: Spacing[keyof Spacing];
      right?: Spacing[keyof Spacing];
    };

const unit = "px";

export const getMarginStyles = (
  margin: MarginValue | undefined,
): CSSProperties => {
  if (margin === undefined) {
    return {};
  }

  if (typeof margin === "number") {
    return { margin: `${margin}${unit}` };
  }

  return {
    ...(margin.top !== undefined && { marginTop: `${margin.top}${unit}` }),
    ...(margin.bottom !== undefined && {
      marginBottom: `${margin.bottom}${unit}`,
    }),
    ...(margin.left !== undefined && { marginLeft: `${margin.left}${unit}` }),
    ...(margin.right !== undefined && {
      marginRight: `${margin.right}${unit}`,
    }),
  };
};
